var studios;

$(function () {
  // Autoscroll if #directions is found

  if ($("body").hasClass("studio-locations")) {
    if (window.location.hash == "#directions") {
      setTimeout(function () {
        $("html,body").animate(
          { scrollTop: $("form").offset().top - 200 },
          1000
        );
      }, 600);
    }

    $.ajax({
      type: "GET",
      url: $("body").attr("data-xml-loc"),
      dataType: "xml",
      success: function (data) {
        parseXML(data);
      },
    });
  }

  $(document).on("click", ".js-closeGoogleWindow", function (e) {
    toll.map.closeInfoWindow();
  });
});

/*
	parseXML
	Parses the xml document, studios.xlm, into an object
	-----------------------------------------------------------------------
*/
function parseXML(xml) {
  studios = new Array();

  $(xml)
    .find("studio")
    .each(function () {
      var address =
        $(this).children("address").text() == "201 Corning Fairbanks Way"
          ? "15 Gleason Street"
          : $(this).children("address").text();
      var url =
        "studio-locations/" +
        $(this).children("states").find("state").eq(0).children("abv").text() +
        "/";
      var studioState = $(this)
        .children("states")
        .find("state")
        .eq(0)
        .children("abv")
        .text();
      var studioRegion = $(this)
        .children("region")
        .text()
        .toLowerCase()
        .replace(/\s/g, "-");

      if (
        studioStateAbv == "" ||
        (studioStateAbv == studioState && studioRegionLoc == studioRegion)
      ) {
        studios.push({
          name: $(this).children("title").text(),
          latlong: $(this).children("latlong").text(),
          onclick: function (d) {
            toll.map.showInfoWindow(d);
          },

          title: $(this).children("title").text(),
          region: $(this).children("region").text(),
          address: address,
          address2: $(this).children("address2").text(),
          phone: $(this).children("phone").text(),

          abv: studioState,
		  url: url + parseUrlString($(this).children("region").text()),
		  icon:       '/images/blue-pin.png',
		  iconWidth:  27,
		  iconHeight: 35,
        });
      }
    });

  var infoWindowHTML =
    '<div class="googleMaps content">' +
    '<button class="js-closeGoogleWindow">x</button>' +
    '<a class="googleMaps title" href="{url}">{name}</a>' +
    '<p class="googleMaps address">{address}</p>' +
    '<p class="googleMaps address">{address2}</p>' +
    '<p class="googleMaps phone">{phone}</p>' +
    '<span class="mapLinks"><a class="googleMaps link sc_tracking " data-label="Marker Link - {name}" href="{url}">View Studio Page</a> &nbsp;&nbsp; <a class="googleMaps link sc_tracking" data-label="Marker Link - {name} Directions" href="{url}#directions">Get Directions</a></span>' +
    "</div>";

  toll.map.init(
    "interactiveMap",
    studios,
    {
      infoWindow: infoWindowHTML,
      zoomControl: true, // or false,
      zoomControlPosition: "BOTTOM_RIGHT", // TOP_LEFT,
      input_startAddress: document.getElementById("start_address"),
      button_getDirections: document.getElementById("getDirections"),
      button_clearDirections: document.getElementById("clear"),
      button_printDirections: document.getElementById("print"),
      text_printedDirections: document.getElementById("directions_print"),
    },
    function () {
      if (studios.length === 1) {
        toll.map.showInfoWindow(studios[0].name);
      }
    }
  );
}

function parseUrlString(title) {
  return title
    .replace(/&/g, "and")
    .replace(/:/g, "")
    .replace(/\s-\s/g, "-")
    .replace(/\s/g, "-")
    .replace(/[^a-z0-9-]/gi, "")
    .toLowerCase();
}
